import { DarkTheme, DefaultTheme, type Theme } from '@react-navigation/native';

/** Minimal nötr navigasyon teması (beyaz / saf siyah, ince sınırlar) */
export const pastelNavigationTheme: Theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#18181b',
    background: '#ffffff',
    card: '#ffffff',
    text: '#18181b',
    border: '#e4e4e7',
    notification: '#18181b',
  },
};

export const pastelNavigationThemeDark: Theme = {
  ...DarkTheme,
  colors: {
    ...DarkTheme.colors,
    primary: '#fafafa',
    background: '#000000',
    card: '#18181b',
    text: '#fafafa',
    border: '#27272a',
    notification: '#fafafa',
  },
};

export function navigationThemeFor(isDark: boolean): Theme {
  return isDark ? pastelNavigationThemeDark : pastelNavigationTheme;
}
